import { SxStyle } from '../../../types/style';

const contentContainer: SxStyle = {
    padding: 2,
    minHeight: 'calc(100vh - 55px)'
};

const contentContainerGridItem1Box: SxStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
};

const contentContainerGridItem1BoxBox: SxStyle = {
    marginRight: '8px'
};

const contentContainerGridItem2Paper: SxStyle = {
    padding: '16px'
};

const contentContainerGridItem2PaperGridItemItemBox: SxStyle = {
    width: '160px', 
    height: '160px',
    borderRadius: '50%'
};

const contentTypography: SxStyle = {
    fontWeight: '700'
};

export const userDetailStyle = {
    contentContainer,
    contentContainerGridItem1Box,
    contentContainerGridItem1BoxBox,
    contentContainerGridItem2Paper,
    contentContainerGridItem2PaperGridItemItemBox,
    contentTypography

};